export function createCurrencyFormatterFromLocale(
    locale: string | string[] | undefined,
    currency: string | undefined,
    minimumFractionDigits = 0,
    maximumFractionDigits = 0
) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    });
}
export function createCurrencyFormatter() {
    return createCurrencyFormatterFromLocale(
        window.odendo.globals.locale,
        window.odendo.globals.currency
    );
}

export function getCurrencySymbol(
    formatter: Intl.NumberFormat
): [string, string] {
    const formatted = formatter.format(NaN);
    const parts = formatted.split("NaN");
    if (parts.length != 2) {
        throw new Error("failed parsing");
    }
    return parts as [string, string];
}
